import React from 'react';
import { ArrowRight, Download, Smartphone, TrendingUp, AlertCircle } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function HeroSection() {
  const scrollToCTA = (e: React.MouseEvent) => {
    e.preventDefault();
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      {/* Top navigation bar */}
      <header className="w-full bg-gray-900 py-2 px-4 border-b border-amber-700" data-id="element-95">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-96">
          <h1 className="text-amber-500 text-xl font-bold" data-id="element-97">
            THE CHARLIE KIRK METHOD
          </h1>
          <p className="text-amber-300 text-xs font-medium" data-id="element-98">
            Leadership for times of chaos
          </p>
        </div>
      </header>
      {/* Main hero section */}
      <section className="w-full bg-gray-900 py-16 px-4" data-id="element-99">
        <div className="max-w-6xl mx-auto" data-id="element-100">
          <div className="flex flex-col md:flex-row items-center" data-id="element-101">
            {/* Left column - Text content */}
            <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-8" data-id="element-102">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-103">
                THE <span className="text-amber-500" data-id="element-104">CHARLIE KIRK</span> METHOD
              </h2>
              <h3 className="text-2xl md:text-3xl font-semibold text-gray-100 mb-8 leading-snug" data-id="element-105">
                In times of chaos… it's not the strongest who survive. It's the
                one who knows how to speak.
              </h3>
              <div className="border-l-4 border-amber-500 pl-4 mb-8" data-id="element-106">
                <h4 className="text-xl font-medium text-gray-200 mb-2" data-id="element-107">
                  Have you ever felt like your voice doesn't matter? Like you
                  have something to say… but no one listens?
                </h4>
              </div>
              <p className="text-lg text-gray-300 mb-8" data-id="element-108">
                Something inside you already knows:{' '}
                <span className="font-semibold text-amber-300" data-id="element-109">
                  Leadership isn't luck. It's a strategy that can be trained.
                </span>
              </p>
              <a href="#cta-section" onClick={scrollToCTA} className="bg-amber-600 hover:bg-amber-700 text-white font-medium py-3 px-6 rounded-md flex items-center transition cursor-pointer" data-id="element-110">
                Download The Leadership Method
                <ArrowRight size={18} className="ml-2" data-id="element-111" />
              </a>
            </div>
            {/* Right column - Product image */}
            <div className="w-full md:w-1/2 relative" data-id="element-112">
              <div className="relative" data-id="element-113">
                <div className="bg-gray-800 p-6 rounded-md shadow-xl border border-gray-700" data-id="element-114">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4S5MqG5bKeKCGdqJ7Q3XwL/ChatGPT_Image_30_sept_2025%2C_16_25_26.webp" alt="The Charlie Kirk Method: How to Become a Leader in Times of Chaos" className="w-full h-auto rounded-md" data-id="element-115" />
                  {/* CTA section */}
                  <div className="mt-6" data-id="element-116">
                    {/* Prices */}
                    <div className="flex justify-center items-center mb-6" data-id="element-117">
                      <span className="text-gray-400 line-through text-xl" data-id="element-118">
                        $39 USD
                      </span>
                      <span className="text-4xl font-bold text-amber-500 ml-4" data-id="element-119">
                        $19 USD
                      </span>
                    </div>
                    {/* Limited time offer notice */}
                    <div className="bg-gray-800 py-4 px-6 flex items-start mb-6 rounded border border-gray-700" data-id="element-120">
                      <AlertCircle size={20} className="text-amber-400 mr-2 flex-shrink-0 mt-1" data-id="element-121" />
                      <p className="text-gray-300 text-left" data-id="element-122">
                        <span className="font-semibold text-amber-300" data-id="element-123">
                          Limited time offer!
                        </span>{' '}
                        After 200 copies sold, the price will return to $39 USD
                      </p>
                    </div>
                    {/* Benefits */}
                    <div className="mb-6" data-id="element-124">
                      <div className="flex items-center py-3" data-id="element-125">
                        <Download size={20} className="text-amber-500 mr-3" data-id="element-126" />
                        <p className="text-gray-200" data-id="element-127">Immediate download</p>
                      </div>
                      <div className="flex items-center py-3" data-id="element-128">
                        <Smartphone size={20} className="text-amber-500 mr-3" data-id="element-129" />
                        <p className="text-gray-200" data-id="element-130">Access from any device</p>
                      </div>
                      <div className="flex items-center py-3" data-id="element-131">
                        <TrendingUp size={20} className="text-amber-500 mr-3" data-id="element-132" />
                        <p className="text-gray-200" data-id="element-133">
                          Start leading from day one
                        </p>
                      </div>
                    </div>
                    {/* FREE BONUSES Banner */}
                    <div className="bg-gray-800 py-3 px-4 mb-6 border-l-4 border-amber-600 rounded" data-id="element-134">
                      <p className="text-amber-400 font-bold text-center" data-id="element-135">
                        Includes 2 FREE LEADERSHIP BONUSES
                      </p>
                    </div>
                    {/* CTA Button */}
                    <a href="https://ebooksociety.co/cart/51475293536537:1" className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-6 rounded-lg text-xl transition inline-block text-center shadow-lg mb-4" data-id="element-136">
                      Download Your Copy Now
                    </a>
                    {/* Payment Icons */}
                    <PaymentIcons data-id="element-137" />
                    {/* Final note */}
                    <p className="text-gray-400 text-sm text-center mt-4 mb-2" data-id="element-138">
                      One-time payment. No subscriptions or hidden charges.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <style jsx data-id="element-139">{`
        @keyframes subtlePulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.03);
          }
        }
        .animate-subtle-pulse {
          animation: subtlePulse 3s infinite ease-in-out;
        }
      `}</style>
    </>;
}